const NoPermission = () => {
  return (
    <div className="contentContainer">
      {`You don't have permissions to access this page`}
    </div>
  );
};

export default NoPermission;
